import React, { ReactNode, memo } from 'react';
import { isDesktop, getPlatformStyles } from '@direct-frontend/platform-code';

import { HStack, StackGap, VStack } from '../Stack';
import { cn } from '../../lib/css/className/className';

getPlatformStyles({
    common: import('./InfoBase.css'),
});

const cls = cn('InfoBaseButtons');

export interface InfoBaseButtonsProps {
    /**
     * Кнопки с рекомендуемыми действиями
     */
    children?: ReactNode;

    /**
     * CSS класс для стилизации
     */
    className?: string;

    /**
     * Отступ между кнопками
     */
    gap?: StackGap | undefined;
}

/**
 * Компонент для отображения блока кнопок в информационных компонентах.
 */
export const InfoBaseButtons = memo<InfoBaseButtonsProps>(function InfoBaseButtons({ children, className, gap }) {
    if (!children) {
        return null;
    }

    const ButtonsStackComponent = isDesktop() ? HStack : VStack;
    const defaultGap = gap ? gap : '6';

    return (
        <ButtonsStackComponent
            gap={isDesktop() ? defaultGap : 'current-geometry'}
            className={cls(null, [className])}
            justifyContent="flex-start"
            flexWrap="wrap"
        >
            {children}
        </ButtonsStackComponent>
    );
});
